<template>
  <div
    class="mt-0 pt-5 pl-0 pr-0 d-flex flex-wrap h-100"
    style="background: rgba(218, 241, 255, 0.1)"
  >
    <!-- <subscribe-modal
      @subscibe="subscribe"
      @subscribed="subscribed"
      @close="close"
      :showSubscribeModal="showSubscribeModal"
    >
    </subscribe-modal> -->
    <card-modal
      v-show="showSubscribeModal"
      @close="close"
      @fetchCards="fetchCards"
    >
    </card-modal>
    <div class="receipt ml-5 mr-5 p-4">
      <div
        class="
          receipt__header
          d-flex
          justify-content-between
          align-items-center
        "
      >
        <div>
          <small class="text-opacity">My Active</small>
          <h6 class="text-bold text-opacity-pale">Payment Cards</h6>
        </div>
        <div>
          <button
            class="pl-3 pr-3 d-flex align-items-center"
            @click="showSubscribeModal = true"
            style="
              background: #0a5685;
              color: white;
              border: none;
              height: 35px;
              border-radius: 20px;
            "
          >
            <h6 class="text-bold text-white text-opacity-pale mb-0">
              + Add Card
            </h6>
          </button> 
        </div>
      </div>
      <div class="receipt__info mt-3">
        <h6 v-if="fetching">Fetching Cards...</h6>
        <h6 v-if="!fetching && cards.length == 0">
          No Card has been added to this account yet!
        </h6>
        <div
          class="card__w p-3 mb-3"
          v-for="(card, index) in cards"
          :key="index"
        >
          <div
            class="d-flex flex-row justify-content-between align-items-center"
          >
            <div>
              <h6 class="text-opacity" style="letter-spacing: 2px">
                CARD NUMBER
              </h6>
             
              <h6 class="text-opacity-pale text-bold h6">
                <span class="pr-3">****</span>
                <span class="pr-3">****</span>
                <span class="pr-3">****</span>
                <span>{{ card.card && card.card.last4 }}</span>
              </h6>
               
            </div>
            
            <div>
              <button v-if="cards.length > 1"
            class="pl-3 pr-3 d-flex align-items-center"
            @click="removeCard(card.id)"
            :disabled="loading"
            style="
              background: #0a5685;
              color: white;
              border: none;
              height: 35px;
              border-radius: 20px;
            "
          >
            <h6 class="text-bold text-white text-opacity-pale mb-0">
              - Remove Card
            </h6>
          </button> 
              <!-- <button
                style="
                  height: 40px;
                  width: 40px;
                  background: darkred;
                  color: white;
                  border: none;
                  border-radius: 5px;
                "
              >
                <i class="zmdi zmdi-delete" style="font-size: 20px"></i>
              </button> -->
            </div>
          </div>

          <div class="d-flex flex-row align-items-center mt-3">
            <div class="mr-5">
              <h6 class="text-opacity" style="letter-spacing: 2px">
                CARD TYPE
              </h6>
              <h6
                class="
                  text-opacity-pale text-bold
                  h6
                  d-flex
                  flex-row
                  align-items-center
                "
              >
                <span
                  class="pr-3"
                  v-html="findCardLogo(card.card && card.card.brand)"
                ></span>
                <span style="text-transform: uppercase">{{
                  card.card && card.card.brand
                }}</span>
              </h6>
            </div>
            <div class="mr-5">
              <h6 class="text-opacity" style="letter-spacing: 2px">CVV</h6>
              <h6 class="text-opacity-pale text-bold h6">***</h6>
            </div>
            <div>
              <h6 class="text-opacity" style="letter-spacing: 2px">EXPIRES</h6>
              <h6 class="text-opacity-pale text-bold h6">
                {{ card.card && card.card.exp_month }}/{{
                  card.card && card.card.exp_year
                }}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.subs {
  background: white;
  width: 60%;
  border-radius: 10px;
}
button {
  &:hover {
    opacity: 0.6;
  }
}
.card__w {
  background: #f7f7f7;
  border-radius: 10px;
}
.receipt {
  width: 100%;
  background: white;

  .receipt__header {
    border-bottom: 2px dashed #f0f3f3;
  }
  .receipt__info ul li:nth-child(2n) {
    background: #f0f3f3;
  }
}
.subs__in {
  background: #f0f3f3;
  border-radius: 10px;

  .subs-icon {
    height: 50px;
    width: 50px;
    background: white;
    border-radius: 50px;
    box-shadow: 0 7px 30px 0 rgba(217, 217, 217, 0.36);
    font-size: 25px;
  }
  .subs-title {
    width: 70%;
  }
  button.no-sub {
    background: transparent;
    border: none;
  }
}
</style>
<script>
// import SubscribeModal from "@/components/Modals/Subscribe.vue";
import CardModal from "@/components/Modals/AddPaymentCard.vue";
import subscription from "@/mixins/subscription";
import {optional} from "@/helpers/random";
import handleError from "@/helpers/error";

export default {
  mixins: [subscription],
  components: { CardModal },
  data() {
    return {
      breadCrumbs: [
        {
          text: "Home",
          href: "#",
        },
        {
          text: "Subscriptions",
          active: true,
        },
      ],
      fetching: true,
      showSubscribeModal: false,
      isSubscribed: false,
      intentData: {},
      cards: [],
      cardIcons: [
        {
          name: "visa",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.662 11.156l.375 1.716h-1.344l.645-1.661.215-.567.109.512zm4.338-5.156v12c0 1.104-.896 2-2 2h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h20c1.104 0 2 .896 2 2zm-17.146 8.971l2.549-5.929h-1.715l-1.585 4.051-.169-.823-.568-2.73c-.098-.377-.383-.489-.734-.502h-2.611l-.021.123c.635.154 1.203.376 1.701.651l1.44 5.16 1.713-.001zm4.823-5.934h-1.619l-1.012 5.941h1.619l1.012-5.941zm4.625 3.999c.006-.676-.425-1.19-1.359-1.614-.566-.275-.913-.458-.909-.736 0-.247.293-.511.927-.511.53-.008.913.107 1.212.228l.145.068.219-1.287c-.321-.121-.824-.25-1.451-.25-1.6 0-2.727.806-2.737 1.961-.009.854.805 1.33 1.419 1.614.63.291.842.477.839.737-.004.398-.503.58-.969.58-.648 0-.992-.09-1.524-.312l-.209-.095-.227 1.33c.378.166 1.078.31 1.804.317 1.702 0 2.807-.797 2.82-2.03zm5.698 1.944l-1.311-5.937h-1.251c-.388 0-.678.106-.848.493l-2.405 5.444h1.7l.341-.893 2.074.003.197.89h1.503z"/></svg>`,
        },
        {
          name: "mastercard",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.465 16.444c0 .193-.128.339-.319.339-.199 0-.321-.153-.321-.339 0-.186.122-.339.321-.339.19.001.319.147.319.339zm-6.814-.338c-.199 0-.321.153-.321.339 0 .186.122.339.321.339.19 0 .319-.146.319-.339 0-.193-.128-.339-.319-.339zm3.391-.011c-.164 0-.257.104-.281.257h.549c-.024-.164-.119-.257-.268-.257zm5.24.011c-.199 0-.321.153-.321.339 0 .186.122.339.321.339.19 0 .319-.146.319-.339 0-.193-.129-.339-.319-.339zm6.718-10.106v12c0 1.104-.896 2-2 2h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h20c1.104 0 2 .896 2 2zm-18.456 4.985c0 2.201 1.784 3.985 3.985 3.985.769 0 1.487-.219 2.096-.596-.967-.813-1.582-2.03-1.582-3.389s.616-2.576 1.582-3.389c-.609-.377-1.326-.596-2.096-.596-2.2 0-3.985 1.784-3.985 3.985zm2.346 5.324c0-.25-.159-.418-.416-.421-.135-.002-.274.04-.372.188-.073-.117-.188-.188-.35-.188-.113 0-.224.033-.31.157v-.131h-.23v1.058h.232v-.587c0-.184.102-.281.259-.281.153 0 .23.1.23.279v.589h.232v-.587c0-.184.106-.281.259-.281.157 0 .232.1.232.279v.589h.234v-.663zm1.297-.394h-.23v.128c-.073-.095-.184-.155-.334-.155-.297 0-.529.232-.529.556 0 .324.232.556.529.556.151 0 .261-.06.334-.155v.128h.23v-1.058zm1.164.74c0-.186-.139-.283-.37-.317l-.108-.016c-.1-.013-.179-.033-.179-.104 0-.078.075-.124.201-.124.135 0 .266.051.33.091l.1-.186c-.111-.073-.263-.111-.432-.111-.268 0-.44.128-.44.339 0 .173.128.279.365.312l.108.016c.126.018.186.051.186.111 0 .082-.084.128-.241.128-.159 0-.274-.051-.352-.111l-.108.179c.126.094.285.138.458.138.305 0 .482-.144.482-.345zm1.025.263l-.066-.197c-.069.04-.144.06-.204.06-.115 0-.153-.071-.153-.177v-.478h.376v-.21h-.376v-.321h-.232v.321h-.215v.21h.215v.483c0 .246.095.392.367.392.1-.001.215-.032.288-.083zm1.173-.474c-.002-.33-.206-.556-.503-.556-.31 0-.527.226-.527.556 0 .336.226.556.542.556.159 0 .305-.04.434-.148l-.113-.17c-.089.071-.201.111-.308.111-.148 0-.283-.069-.317-.259h.786l.006-.09zm.908-.526l-.164-.029c-.133 0-.219.062-.279.155v-.128h-.228v1.058h.23v-.594c0-.175.075-.272.226-.272l.144.027.071-.217zm.308.526c0-.204.135-.336.319-.339.1 0 .19.033.277.095l.111-.186c-.115-.091-.221-.126-.381-.126-.341 0-.564.235-.564.556s.222.556.563.556c.159 0 .266-.035.381-.126l-.111-.186c-.086.062-.177.095-.277.095-.183-.002-.318-.135-.318-.339zm1.916-.529h-.23v.128c-.073-.095-.184-.155-.334-.155-.297 0-.529.232-.529.556 0 .323.232.556.529.556.151 0 .261-.06.334-.155v.128h.23v-1.058zm.974.003l-.164-.029c-.133 0-.219.062-.279.155v-.128h-.228v1.058h.23v-.594c0-.175.075-.272.226-.272l.144.027.071-.217zm1.162-.428h-.23v.553c-.073-.095-.184-.155-.334-.155-.297 0-.529.232-.529.556 0 .323.232.556.529.556.151 0 .261-.06.334-.155v.128h.23v-1.483zm.639-4.505c0-2.201-1.785-3.985-3.985-3.985s-3.985 1.784-3.985 3.985c0 2.201 1.784 3.985 3.985 3.985s3.985-1.784 3.985-3.985z"/></svg>`,
        },
      ],
      loading: false
    };
  },
  methods: {
    subscribe() {
      this.showSubscribeModal = true;
    },
    subscribed(d) {
      this.isSubscribed = true;
      this.intentData = d;
    },
    close(d) {
      this.showSubscribeModal = false;
    },
    findCardLogo(name) {
      return this.cardIcons.find((s) => {
        return s.name == name;
      }).icon;
    },
    fetchCards() {
      this.$store.dispatch("global/getStripeKey").then((s) => {
        this.cards = optional(s, 'data.data.payment_methods');
        this.fetching = false;
      });
    },
    async removeCard(id) {
      let r = confirm('Are you sure to remove this card?');
      if(!r) {
        return;
      }
      this.loading = true;
        this.$store
          .dispatch("payments/removeCard", id)
          .then(() => {
            this.$toast.success('Card successfully removed', {
            position: "top-right",
            duration: 3000
          });
          this.cards = this.cards.filter(s => s.id != id);
          })
          .catch((error) => {
            let errorMessage = `Failed to remove card`;

            handleError(this, error, errorMessage);
            
          }).finally(() => {
            this.loading = false;
          });
    }
  },
  mounted() {
    Promise.all([this.fetchCards()]);
  },
};
</script>